import { useGlobalState, useStatsigLayer } from '@/hooks';
import { LanguageCode } from '@/interfaces';
import type { IPmtOnboardingPopup } from '@/modules/pmt/interfaces';
import { getTextByLanguage } from '@/modules/pmt/utils';

export const usePmtOnboardingPopupCopy = (popUp: IPmtOnboardingPopup | undefined): IPmtOnboardingPopup | undefined => {
  const { pmtCurrentLanguageCode, isLoggedIn } = useGlobalState();
  const { get, isReady: isAnonymousReady } = useStatsigLayer('track_my_parcel_copy_layer');
  const { get: getSignedIn, isReady: isSignedInReady } = useStatsigLayer('track_my_parcel_signed_in_layer');

  if (!popUp) return undefined;

  const isEnglish = pmtCurrentLanguageCode === LanguageCode.English;

  if (!isEnglish || !isAnonymousReady || !isSignedInReady) return popUp;

  const mergedPropositionList = popUp.joinUsValuePropositionList?.map((item, index) => {
    const i = index + 1;
    return {
      ...item,
      title: get(`proposition_${i}_title`, getTextByLanguage(item.title ?? '', 'en')),
      description: get(`proposition_${i}_description`, getTextByLanguage(item.description ?? '', 'en')),
    };
  });

  // Hero image is tested per audience: guests bucket by stableID, signed-in users by userID.
  // Empty by default so the CMS hero image stays in place when the experiment does not set it
  const heroImageUrl = (isLoggedIn ? getSignedIn : get)('hero_image_url', '');

  // Drop the CMS contentType: it describes the CMS asset (e.g. SVG), not the Statsig one
  const heroImage = heroImageUrl ? { ...popUp.heroImage, url: heroImageUrl, contentType: undefined } : popUp.heroImage;

  return {
    ...popUp,
    heroImage,
    joinUsHeader: get('join_us_header', popUp.joinUsHeader),
    joinUsValuePropositionList: mergedPropositionList ?? popUp.joinUsValuePropositionList,
    joinUsDesktopMainText: get('join_us_main_text', popUp.joinUsDesktopMainText),
    joinUsSubtext: get('join_us_subtext', popUp.joinUsSubtext),
    subPmcNewsletterText: get('newsletter_checkbox_label', popUp.subPmcNewsletterText),
    newsletterSubText: get('newsletter_subtext', popUp.newsletterSubText),
  };
};
